<!-- 添加为商品 -->
<template>
    <div id="">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="100px">
            <el-form-item label="汽配名称">
                <el-input v-model="formData.Cn" readonly></el-input>
            </el-form-item>
            <el-form-item label="数量" prop="count">
                <el-input v-model.number="formData.count" type="number" min="1"></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="unit">
                <el-select v-model="formData.unit" placeholder="请选择" style="width: 100%">
                    <el-option
                            v-for="item in Unit"
                            :key="item"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" 备注">
                <el-input v-model.trim="formData.remark" ></el-input>
            </el-form-item>
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" @click="submitForm">创建询价单</el-button>
            <el-button @click="close()">取消</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        props:{
            goodMsg:Object,
        },
        components: {

        },
        data(){
            let checkInt = this.$util.checkInt
            return {
                Unit:['件','个','片','只','台','升','毫升'],
                formData:{
                    "Cn":"",
                    "partId": "",
                    "count": 0,
                    "unit": "件",
                    "remark": ""
                },
                rules: {
                    count: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    unit: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                },
            }
        },
        mounted(){
            this.formData.Cn = this.goodMsg.Cn
            this.formData.partId = this.goodMsg.Id
        },
        watch:{
            goodMsg(val){
                this.formData.Cn = val.Cn
                this.formData.partId = val.Id
            }
        },
        methods:{
            close(){
                this.$emit('closeDialog')
            },
            resetForm(){
                this.$refs.formData.clearValidate();
            },
            submitForm(){
                this.$refs.formData.validate((valid) => {
                    if (valid) {
                        this.axios.post('/Inquiry/AddInquiryBills', {
                            UId:this.$store.state.customerMsg.uId,// 客户id
                            BillObjects:[this.formData]
                        })
                            .then((response) => {
                                this.$util.successMsg('创建询价单成功')
                                this.$emit('closeDialog')
                            })
                            .catch((error) => {
                                console.log(error);
                                this.$message.error('创建询价单失败！');
                            });
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .dialog-footer {
        text-align: right;
        margin-right: 20px;
    }
    .prv-ctn {
        display: flex;
        padding-top: 10px;
    }
</style>
